import { TRACKING_EVENTS } from "../constants/trackingEvents";
import { trackEvent } from "./tracking";

const KEY_FIRST_SALE = "uplevo_evt_first_sale";
const KEY_FIRST_INVENTORY = "uplevo_evt_first_inventory";

/** Fires once per browser (localStorage) after the first successful POS checkout. */
export function trackFirstSaleCompletedOnce() {
  try {
    if (localStorage.getItem(KEY_FIRST_SALE)) return;
    localStorage.setItem(KEY_FIRST_SALE, "1");
    trackEvent(TRACKING_EVENTS.FIRST_SALE_COMPLETED);
  } catch {
    // ignore quota / private mode
  }
}

/** Fires once per browser after the first successful inventory add (manual entry or bulk commit). */
export function trackFirstInventoryAddedOnce() {
  try {
    if (localStorage.getItem(KEY_FIRST_INVENTORY)) return;
    localStorage.setItem(KEY_FIRST_INVENTORY, "1");
    trackEvent(TRACKING_EVENTS.FIRST_INVENTORY_ADDED);
  } catch {
    // ignore
  }
}
